// ================================================================================
// script-jquery.js
// 案件用のスクリプトファイル
// ================================================================================

// DOM Read for jQuery
// --------------------------------------------------------------- //

$(function() {

	$('.js-accordion-button').click(function() {
		$(this).toggleClass('is-opened');
		$(this).closest('.wp-block-faq-item').find('.wp-block-faq-item__content').slideToggle();
	} );

});

